module.exports = __webpack_public_path__ + "assets/img/func7.30adc2af.png";